// extracted by mini-css-extract-plugin
export var container = "index-module--container--1BMTx";
export var according = "index-module--according--3CeOm";
export var paddingLeft = "index-module--paddingLeft--15Zzc";
export var link = "index-module--link--2v1pL";